/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Values of one analytic export column
 */
export interface AnalyticExportColumn { 
    /**
     * The name of the column
     */
    name?: string;
    /**
     * The type of the column
     */
    type?: string;
    /**
     * The value of the column
     */
    value?: string;
}

